export default __webpack_public_path__ + "static/media/army_31.9791f413.jpg";